<template>
  <svg :fill="color" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.75 2C14.9409 2 15.9156 2.92516 15.9948 4.09595L16 4.25C16 4.16531 15.9953 4.0817 15.9862 3.99944L17.75 4C18.9926 4 20 5.00736 20 6.25V19.75C20 20.9926 18.9926 22 17.75 22H6.25C5.00736 22 4 20.9926 4 19.75V6.25C4 5.00736 5.00736 4 6.25 4L8.01379 3.99944C8.00733 4.05774 8.0031 4.11671 8.00119 4.17626L8 4.25C8 3.00736 9.00736 2 10.25 2H13.75ZM13.75 6.5H10.25C9.45595 6.5 8.75797 6.08867 8.35751 5.46746L8.37902 5.5002L6.25 5.5C5.83579 5.5 5.5 5.83579 5.5 6.25V19.75C5.5 20.1642 5.83579 20.5 6.25 20.5H17.75C18.1642 20.5 18.5 20.1642 18.5 19.75V6.25C18.5 5.83579 18.1642 5.5 17.75 5.5L15.621 5.5002L15.6425 5.46746C15.242 6.08867 14.5441 6.5 13.75 6.5ZM13.75 3.5H10.25C9.83579 3.5 9.5 3.83579 9.5 4.25C9.5 4.66421 9.83579 5 10.25 5H13.75C14.1642 5 14.5 4.66421 14.5 4.25C14.5 3.83579 14.1642 3.5 13.75 3.5ZM8 14.5H12C12.4142 14.5 12.75 14.1642 12.75 13.75C12.75 13.3358 12.4142 13 12 13H8C7.58579 13 7.25 13.3358 7.25 13.75C7.25 14.1642 7.58579 14.5 8 14.5ZM8 10.5H16C16.4142 10.5 16.75 10.1642 16.75 9.75C16.75 9.33579 16.4142 9 16 9H8C7.58579 9 7.25 9.33579 7.25 9.75C7.25 10.1642 7.58579 10.5 8 10.5ZM8 18.5H14C14.4142 18.5 14.75 18.1642 14.75 17.75C14.75 17.3358 14.4142 17 14 17H8C7.58579 17 7.25 17.3358 7.25 17.75C7.25 18.1642 7.58579 18.5 8 18.5Z" />
  </svg>
</template>

<script>
export default {
  name: "IconClipboard",
  props: {
    color: {
      type: String,
      default: "#163B61"
    }
  }
}
</script>

<style lang="scss" scoped>

</style>